module.exports = __webpack_public_path__ + "img/stickers-bilan-x3.cfad1237.jpg";